import React from "react";
import { useTranslation } from "react-i18next";
import "./timesheet-list.style.css";
import TimesheetListContainer from "./TimesheetListContainer";

function PendingTimesheetsView() {
    const { t } = useTranslation();

    return (
        <div className="container">
            <h2>{t('timesheets.pending')}</h2>
            <TimesheetListContainer statusFilter="pending" />
        </div>
    );
}

export default PendingTimesheetsView;
